module.exports = __webpack_public_path__ + "static/media/logo-토닥@3x.6411bf6f.png";